import get from 'lodash.get';
import forEach from 'lodash.foreach';
import orderBy from 'lodash.orderby';
import map from 'lodash.map';
import { isUndefinedOrNullOrEmpty } from '@/utilities';
import ConditionReportSection from './ConditionReportSection';

export default class ConditionReport {
  constructor(conditionReport, legacyConditionReport) {
    // Convert legacy CR into CR1.5+ if applicable - ETC
    if (!isUndefinedOrNullOrEmpty(conditionReport)) {
      this.condition_report = conditionReport;
    } else if (!isUndefinedOrNullOrEmpty(legacyConditionReport)) {
      const sortedLegacyConditionReport = this.sortLegacyConditionReport(legacyConditionReport);
      const formattedLegacyConditionReport = this
        .formatLegacyCRIntoNewCRFormat(sortedLegacyConditionReport);
      this.condition_report = formattedLegacyConditionReport;
    }

    if (this.sections.length) {
      const sections = [];
      forEach(this.condition_report.sections, (section) => {
        sections.push(new ConditionReportSection(section));
      });
      this.condition_report.sections = sections;
    }
  }

  get sections() {
    return get(this, 'condition_report.sections', []);
  }

  // eslint-disable-next-line class-methods-use-this
  sortLegacyConditionReport(legacyConditionReport) {
    let sortedLegacyConditionReport = legacyConditionReport;
    if (sortedLegacyConditionReport && sortedLegacyConditionReport.sections) {
      orderBy(map(sortedLegacyConditionReport.sections, (s) => {
        const section = s;
        if (section.subsections) {
          section.subsections = orderBy(map(section.subsections, (sub) => {
            const subsection = sub;
            if (sub.questions) {
              subsection.questions = orderBy(map(subsection.questions, (q) => {
                const question = q;
                question.sort_order = parseInt(question.sort_order, 10);
                return question;
              }), 'sort_order');
            }
            subsection.sort_order = parseInt(subsection.sort_order, 10);
            return sub;
          }), 'sort_order');
        }
        section.sort_order = parseInt(section.sort_order, 10);
        return section;
      }), 'sort_order');
    } else {
      sortedLegacyConditionReport = {
        sections: [],
      };
    }

    return sortedLegacyConditionReport;
  }

  formatLegacyCRIntoNewCRFormat(sortedLegacyConditionReport) {
    let reformattedQuestions;
    forEach(sortedLegacyConditionReport.sections, (s) => {
      const section = s;
      // section title is now section_name
      section.section_name = section.title;
      forEach(section.subsections, (sub) => {
        reformattedQuestions = [];
        forEach(sub.questions, (q) => {
          /*
          * Create a question object from the legacy condition report question
          * that matches the new question object format of the new CR response questions
          */
          if (q.yes_no !== null) {
            const newlyFormattedQuestion = {
              question_type: 'LEGACY',
              question_title: this.capitalizeFirstLetter(q.title.replace('?', '')),
              answer: {
                value: q.seller_disclosure ? q.seller_disclosure.trim() : '',
              },
              selected: parseInt(q.yes_no, 10) === 1,
              yellow_light: parseInt(q.yellow_light, 10) === 1,
            };

            reformattedQuestions.push(newlyFormattedQuestion);
          }
        });
        /*
        * The new CR 1.5 response format doesn't have a 'subsection' property
        * and it has the questions on the section property now so we need to
        * move the reformatted questions to the parent 'section' property
        */
        section.questions = reformattedQuestions;
      });
    });
    return sortedLegacyConditionReport;
  }

  // TODO - Do we need to this anywhere else? If so, maybe a filter instead. -ETC
  // eslint-disable-next-line class-methods-use-this
  capitalizeFirstLetter(value) {
    const abbreviationsToKeepCapitalized = ['ACV', 'ABS/', 'TMU', '2WD', '4WD', 'A/C', 'SRS', 'TPMS', 'PDR'];

    let str = value.toLowerCase();

    abbreviationsToKeepCapitalized.forEach((abbr) => {
      str = str.replace(new RegExp(abbr, 'ig'), abbr);
    });
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
